module.exports = __webpack_public_path__ + "assets/img/discernment_license_scene2.fa49fb9c.png";